import axios from 'axios';
import cookie from '../../cookieHelper/cookie';

export default function getFilteredStories(data) {
    try {
        const page = data.page || 0;
        const size = data.size || 999;
        const status = (data.status && data.status >= 0) ? data.status : '';
        const companyId = data.companyId || '';
        const origin = data.origin || '';
        const mediaType = data.mediaType || '';
        const storyTypeFilter = data.storyTypeFilter || '';
    
    
        const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/getFilteredStoriesv2?companyId=' + companyId + '&status=' + status + '&origin=' + origin + '&page=' + page + '&size=' + size + '&mediaType=' + mediaType + '&storyTypeFilter=' + storyTypeFilter;
    
        console.log("API_URL", API_URL)
        const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);
    
        return (
            axios.get(API_URL, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json',
                }
            })
            .then(res => {
                // console.log('getFilteredStories: ', res);
                return res.data;
            })
            .catch(err => {
                // console.error('Error fetching stories: ', err);
                return err;
            })
        );
        
    } catch (error) {
        console.log("debug err", error);
    }
}